module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgMyAyIj48cGF0aCBmaWxsPSIjMDA5NTQzIiBkPSJNMCAwaDN2MkgweiIvPjxwYXRoIGQ9Ik0wIDJsMi0yaDF2MnoiIGZpbGw9IiNGQkRFNEEiLz48cGF0aCBkPSJNMyAwdjJIMXoiIGZpbGw9IiNEQzI0MUYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cog.svg
// module id = w2Jc
// module chunks = 0